import { Tooltip } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { LogoOnly, LogoTextOnly } from "../../assets/logos";
import { RelodeTheme } from "../styles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                alignItems: "center",
                color: theme.palette.common.black,
                cursor: "pointer",
                display: "flex",
                height: theme.relode.sizes.appBarHeight,
                position: "relative",
                paddingLeft: 16,
            },
            logo: {
                height: 34,
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                transition: theme.transitions.create(["transform"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
                transform: "rotate(0deg)",
                transformOrigin: "17px center",
            },
            logoClosed: {
                transition: theme.transitions.create(["transform"], {
                    easing: theme.transitions.easing.easeIn,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                transform: "rotate(360deg)",
            },
            logoText: {
                position: "absolute",
                left: 40,
                transition: theme.transitions.create(["width", "left"], {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            logoTextClosed: {
                width: 0,
                left: 48,
                transition: theme.transitions.create(["width", "left"], {
                    easing: theme.transitions.easing.easeIn,
                    duration: theme.transitions.duration.leavingScreen,
                }),
            },
        }),
    { name: "RelodeLogo" }
);

interface Props {
    isOpen?: boolean;
    onClick?: () => void;
    className?: string;
}

export const Logo = (props: Props) => {
    const { className: classNameProp, isOpen, onClick, ...other } = props;

    const classes = useStyles({});
    const logoTooltip = `${appConfig.appName} ${appConfig.buildNumber}`;

    const rootClasses = classnames(
        {
            [classes.root]: true,
        },
        classNameProp
    );

    const logoClasses = classnames({
        [classes.logo]: true,
        [classes.logoClosed]: !isOpen,
    });

    const logoTextClasses = classnames({
        [classes.logoText]: true,
        [classes.logoTextClosed]: !isOpen,
    });

    return (
        <Tooltip placement="bottom-start" title={logoTooltip}>
            <div className={rootClasses} onClick={onClick} {...other}>
                <LogoOnly className={logoClasses} />
                <LogoTextOnly className={logoTextClasses} />
            </div>
        </Tooltip>
    );
};
